<template>
    <div
      class="end-screen"
      :style="backdropStyle"
    >
      <div class="scrim"></div>

        <div class="top-nav" >
            <button class="icon-btn" type="button" aria-label="Back" @click="cancel">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> <line x1="19" y1="12" x2="5" y2="12" /> <polyline points="12 19 5 12 12 5" /> </svg>
            </button>
        </div>


      <div class="content">
        <div class="info">
          <div class="title-row">
            <div v-if="related.poster_path" class="poster">
              <img :src="related.poster_path" :alt="titleText" />
            </div>

            <div class="text">
              <p class="kicker">Coming up next</p>
              <h1 class="title">{{ titleText }}</h1>

              <div class="meta">
                <span v-if="year" class="meta-item">{{ year }}</span>

                <span v-if="ratingText" class="meta-item rating">
                  <svg viewBox="0 0 20 20" class="star">
                    <path d="M10 1.5l2.59 5.25 5.79.84-4.19 4.08.99 5.77L10 14.77l-5.18 2.67.99-5.77L1.62 7.6l5.79-.84L10 1.5z"/>
                  </svg>
                  {{ ratingText }}
                </span>

                <span class="meta-item">{{ mediaTypeLabel }}</span>
              </div>

              <div v-if="related.genres.length" class="chips">
                <span v-for="genre in related.genres" :key="genre" class="chip">
                  {{ genre }}
                </span>
              </div>

              <p v-if="related.overview" class="overview">
                {{ related.overview }}
              </p>
            </div>
          </div>
        </div>

        <div class="actions">
          <button
            type="button"
            class="ring-btn"
            :aria-label="'Play ' + titleText + ' now'"
            @click="play"
          >
            <svg viewBox="0 0 120 120" class="ring">
              <circle class="ring-track" cx="60" cy="60" r="52" />
              <circle
                class="ring-progress"
                cx="60" cy="60" r="52"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="dashOffset"
              />
            </svg>
            <svg viewBox="0 0 24 24" class="play-icon">
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>

          <p v-if="showTimer" class="timer-label">
            Next in {{ countdown }}s
          </p>

          <div class="buttons">
            <button type="button" class="link" @click="cancel" v-if="type === 'movie'">
              Cancel
            </button>

            <button  type="button" class="ghost-btn" >
              <svg viewBox="0 0 20 20" class="grid-icon">
                <rect x="2" y="2" width="7" height="7" rx="1" />
                <rect x="11" y="2" width="7" height="7" rx="1" />
                <rect x="2" y="11" width="7" height="7" rx="1" />
                <rect x="11" y="11" width="7" height="7" rx="1" />
              </svg>
                More Like this
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
const COUNTDOWN_SECONDS = 30;
const RADIUS = 52;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export default {
  name: 'EndScreen',
  props: {
    related: Object,
    goBack: Function,
    type: String,
    apc: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      countdown: COUNTDOWN_SECONDS,
      timer: null,
      showTimer: false,
      pendingAction: null,
    };
  },
  computed: {
    titleText() {
      return this.related.name || this.related.title;
    },
    year() {
      const date = this.related.first_air_date || this.related.release_date;
      return date ? date.slice(0, 4) : null;
    },
    ratingText() {
      return this.related.vote_average ? this.related.vote_average.toFixed(1) : null;
    },
    mediaTypeLabel() {
      const type = this.related.media_type || this.related.type;
      return type === 'tv' ? 'Series' : 'Film';
    },
    backdropStyle() {
      return this.related.backdrop_path
        ? { '--end-screen-backdrop': `url(${this.related.backdrop_path})` }
        : {};
    },
    circumference() {
      return CIRCUMFERENCE;
    },
    dashOffset() {
      return CIRCUMFERENCE * (this.countdown / COUNTDOWN_SECONDS);
    },
  },
  mounted() {
    if (!this.related) return;

    if (this.apc < 1) {
      if(this.type === 'movie'){
        this.startCountdown();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    startCountdown() {
      this.showTimer = true;
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.play(true);
        }
      }, 1000);
    },
    play(autoPlayed=false) {
      let apcNext = 0
      if(autoPlayed){
        apcNext = this.apc + 1
      }
      this.$router.push(`/theater?mode=od&type=${this.type}&id=${this.related.id}&apc=${apcNext}`)

    },
    cancel() {
      clearInterval(this.timer);
       this.goBack()
    },
    browseMore() { },
  },
};
</script>

<style scoped lang="scss">

.end-screen {
  --end-screen-ink: #f3ede0;
  --end-screen-ink-dim: rgba(243, 237, 224, 0.68);
  --end-screen-gold: #d9a44a;
  --end-screen-gold-dim: rgba(217, 164, 74, 0.4);
  --end-screen-black: #07070a;

  position: relative;
  width: 100%;
  height: 90vh;
  padding-bottom: 10vh;
  overflow: hidden;
  background-color: var(--end-screen-black);
  color: var(--end-screen-ink);
  z-index: 999;

  &::before {
    content: '';
    position: absolute;
    inset: -5%;
    background-image: var(--end-screen-backdrop);
    background-size: cover;
    background-position: center;
  }

  .scrim {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(0deg, rgba(4, 4, 6, 0.96) 0%, rgba(4, 4, 6, 0.75) 28%, rgba(4, 4, 6, 0.25) 58%, rgba(4, 4, 6, 0.15) 100%),
      linear-gradient(90deg, rgba(4, 4, 6, 0.55) 0%, rgba(4, 4, 6, 0.1) 45%, rgba(4, 4, 6, 0.55) 100%);
  }

  .top-nav {
    position: absolute;
    top: 0;
    left: 0;
    padding: 28px 40px;
    cursor: pointer;
    z-index: 999;
  }

  .content {
    position: relative;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 32px;
    padding: 48px;

    .title-row {
      display: flex;
      align-items: flex-end;
      gap: 24px;

      .poster {
        flex-shrink: 0;
        width: 400px;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid rgba(243, 237, 224, 0.18);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);

        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }

      .text {
        max-width: 460px;

        .kicker {
          margin: 0 0 6px;
          font-size: 13px;
          color: var(--end-screen-gold);
          font-weight: 500;
        }

        .title {
          padding: 0;
          margin: 0 0 12px;
          font-weight: 600;
          font-size: 34px;
          line-height: 1.15;
        }

        .meta {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 12px;
          font-size: 14px;
          color: var(--end-screen-ink-dim);

          .rating {
            display: inline-flex;
            align-items: center;
            gap: 5px;

            .star {
              width: 13px;
              height: 13px;
              fill: var(--end-screen-gold);
            }
          }
        }

        .chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 14px;

          .chip {
            font-size: 12px;
            padding: 4px 11px;
            border-radius: 999px;
            border: 1px solid var(--end-screen-gold-dim);
            color: var(--end-screen-ink-dim);
          }
        }

        .overview {
          margin: 0;
          font-size: 15px;
          line-height: 1.55;
          color: var(--end-screen-ink-dim);
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }

    .actions {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;

      .ring-btn {
        position: relative;
        width: 104px;
        height: 104px;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;

        &:focus-visible {
          outline: 2px solid var(--end-screen-gold);
          outline-offset: 4px;
          border-radius: 50%;
        }

        .ring {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          transform: rotate(-90deg);

          .ring-track {
            fill: rgba(255, 255, 255, 0.06);
            stroke: rgba(243, 237, 224, 0.16);
            stroke-width: 3;
          }

          .ring-progress {
            fill: none;
            stroke: var(--end-screen-gold);
            stroke-width: 3;
            stroke-linecap: round;
            transition: stroke-dashoffset 1s linear;
          }
        }

        .play-icon {
          position: absolute;
          top: 50%;
          left: 54%;
          width: 30px;
          height: 30px;
          transform: translate(-50%, -50%);
          fill: var(--end-screen-ink);
        }
      }

      .timer-label {
        margin: 0;
        font-size: 13px;
        color: var(--end-screen-ink-dim);
      }

      .buttons {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 8px;

        .link {
          background: none;
          border: none;
          padding: 0;
          font-size: 13px;
          color: var(--end-screen-ink-dim);
          cursor: pointer;

          &:hover {
            color: var(--end-screen-ink);
          }

          &:focus-visible {
            outline: 2px solid var(--end-screen-gold);
            outline-offset: 3px;
          }
        }

        .ghost-btn {
          display: none;
          //display: inline-flex;
          align-items: center;
          gap: 7px;
          background: none;
          border: 1px solid rgba(243, 237, 224, 0.3);
          border-radius: 6px;
          padding: 7px 14px;
          font-size: 13px;
          color: var(--end-screen-ink);
          cursor: pointer;
          transition: border-color 0.2s ease, background-color 0.2s ease;

          &:hover {
            border-color: var(--end-screen-gold);
            background-color: rgba(217, 164, 74, 0.08);
          }

          &:focus-visible {
            outline: 2px solid var(--end-screen-gold);
            outline-offset: 3px;
          }

          .grid-icon {
            width: 12px;
            height: 12px;
            fill: currentColor;
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .end-screen {
    .content {
      flex-direction: column;
      align-items: flex-start;
      padding: 24px;
      gap: 24px;
    }

    .title-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    .poster {
      width: 84px;
    }

    .title {
      font-size: 26px;
    }

    .text {
      max-width: 100%;
    }

    .actions {
      align-self: center;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .end-screen {
    &::before {
      animation: none;
    }

    .ring-progress {
      transition: none;
    }
  }
}
</style>
